import AgGridWrapper from "../../../../../components/AgGridWrapper/AgGridWrapper";
import ActionButtons from "../../../../../components/ActionButtons";
import { changeStatus, setGrid } from "../../utils/slice";
import columnDefs from "./columnDefs";
import { useAppSelector } from "../../../../../utils/hooks/hooks";
import ConfirmModal from "../../../../../components/Modals/ConfirmModal";
import { useState } from "react";
import { RootState } from "../../../../../store/app";

/**
 * Renders a listing component for the VR Training Location module with action buttons.
 *
 * @param {Object} props - The component props.
 * @param {Object} props.moduleInfo - Information about the module.
 * @param {Function} props.handleViewClick - The click event handler for viewing the details of a record.
 * @param {Function} props.handleDeleteClick - The click event handler for deleting the details of a record.
 * @param {Function} props.handleEditClick - The click event handler for editing the details of a record.
 * @return {JSX.Element} The rendered component.
 */
const Listing: React.FC<any> = ({
  moduleInfo,
  handleViewClick,
  handleDeleteClick,
  handleEditClick,
}) => {
  const vrTrainingLocation = useAppSelector(
    (state: RootState) => state.vrTrainingLocation
  );
  const [statusData, setStatusData] = useState<any>();

  const ActionRenderer = (props: any) => {
    return (
      <ActionButtons
        data={props}
        view={{
          action: handleViewClick,
          permissionKey: `${moduleInfo.permissionKeyPrefix}_DETAILS`,
        }}
        edit={{
          action: handleEditClick,
          permissionKey: `${moduleInfo.permissionKeyPrefix}_UPDATE`,
        }}
        deleteButton={{
          action: handleDeleteClick,
          permissionKey: `${moduleInfo.permissionKeyPrefix}_DELETE`,
        }}
      />
    );
  };

  return (
    <>
      <ConfirmModal
        titleName={moduleInfo.title}
        data={statusData}
        close={() => setStatusData(null)}
        callApi={changeStatus}
      />
      <AgGridWrapper
        components={{
          ActionRenderer,
        }}
        rowData={vrTrainingLocation.rowData}
        onGridReadyWithDispatch={setGrid}
        columnDefs={columnDefs}
        context={{ setStatusData }}
        paginationPageSize={vrTrainingLocation.perPage}
        cacheBlockSize={vrTrainingLocation.perPage}
      />
    </>
  );
};

export default Listing;
